// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-embed-map-module{margin:20px 0;text-align:center}.v-embed-map-module iframe{width:90.25%;height:auto;aspect-ratio:1/1}@media (min-width:768px){.v-embed-map-module iframe{width:50%;height:auto;aspect-ratio:3/2}}", ""]);
// Exports
module.exports = exports;
